import { render, staticRenderFns } from "./LiveQueueStrip.vue?vue&type=template&id=b8946750&scoped=true"
import script from "./LiveQueueStrip.vue?vue&type=script&lang=js"
export * from "./LiveQueueStrip.vue?vue&type=script&lang=js"
import style0 from "./LiveQueueStrip.vue?vue&type=style&index=0&id=b8946750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8946750",
  null
  
)

export default component.exports